import React from "react";

import "./styles.scss"
import ESGChatMain from "../../esg-chat/esg-chat";


const PromptEvaluation = () => {
    return (
        <div className="prompt-evaluation-main">
            <ESGChatMain 
            searchType="Company"
            showDisclosuresSection
            promptEvaluation={true}
            />
        </div>
    )
}

export default PromptEvaluation;